export default __webpack_public_path__ + "static/media/home-solid.38353f81.svg";